<!--suppress ALL -->

<template>
  <tr>
    <td class="text-xs-center">
      {{ user.name }}
    </td>
    <td class="text-xs-center">
      {{ user.last_name }}
    </td>
    <td class="text-xs-center">
      {{ user.email }}
    </td>
    <td class="text-xs-center">
      {{ user.clients_name }}
    </td>
    <td class="text-xs-center">
      {{ user.branches_name }}
    </td>
    <td class="text-xs-center">
      {{ role }}
    </td>
    <td>
      <edit-btn @click="onEdit" :tooltip-text="$t('attributes.edit')"/>
      <remove-btn :tooltip-text="$t('attributes.remove')"/>
      <v-btn v-if="isManager" @click="loginAs" color="primary" :loading="loading">{{ $t("pages.userRow") }}</v-btn>
      <v-btn v-if="isManager && [5,6,7,8].includes(+user.role)" @click="createApiKey" color="success" :loading="loading">יצירת מפתח</v-btn>
    </td>

  </tr>
</template>

<script>

import {types} from "src/store/modules/User.module";
import RemoveBtn from "src/scaffoldings/RemoveBtn";
import EditBtn from "src/scaffoldings/EditBtn";
import RowMixin from "src/mixins/RowMixin";
import RoleManager from "dev/helpers/RoleManager";
import AuthService from "dev/packages/AuthService";

export default {
  name: "user-row",
  props: {
    user: {required: true}
  },
  components: {EditBtn, RemoveBtn},
  mixins: [new RowMixin(types, "user")],
  data() {
    return {
      loading: false
    };
  },
  computed: {
    role() {
      return RoleManager.toString(this.user.role);
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isManager() {
      return this.$store.getters.isManager;
    }
  },
  methods: {
    async loginAs() {
      this.loading = true;
      await AuthService.loginAs(this.user.id);
      window.location.replace("/");
    },
    doRemove() {
      this.$store.dispatch(types.REMOVE, this.user);
    },
    onEdit() {
      this.$emit("edit", this.user);
    },
    createApiKey(userId) {
      swal.fire({
        icon: "warning",
        title: "שים לב!",
        text: "יצירת מפתח חדש תמחק את המפתחות הקודמים",
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        preConfirm: async () => {
          try {
            const githubUrl = ` /api/create/keys/${this.user.id} `;
            const response = await fetch(githubUrl);
            if (!response.ok) {
              return swal.showValidationMessage(`
          ${JSON.stringify(await response.json())}
        `);
            }
            return response.json();
          } catch (error) {
            swal.showValidationMessage(`
        Request failed: ${error}
      `);
          }
        },
        allowOutsideClick: false
      })

          .then((result) => {
            console.log(result);
            /* Read more about isConfirmed, isDenied below */
            if (result.value) {
              // swal.fire("יש להעתיק את המפתח ולשולחו בכל בקשה",result.value.token, "success");
              swal.fire({
                title: "לחץ על הטקסט כדי להעתיק",
                html: `<p id="copyText" style="cursor: pointer; color: blue;">${result.value.token}</p>`,
                icon: "info",
                didOpen: () => {
                  console.log(1)
                  document.getElementById("copyText").addEventListener("click", () => {
                    navigator.clipboard.writeText(result.value.token).then(() => {
                      swal.fire("הועתק!", "הטקסט הועתק ללוח.", "success");
                    });
                  });
                }
              });
            }
          });
      ;
    }
  }
};
</script>

<style>

</style>
